var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.88,40.981H36.893a1.445,1.445,0,1,0,0-2.867H23.88a1.539,1.539,0,0,1-1.627-1.434V23.3a1.539,1.539,0,0,1,1.627-1.434H43.942A1.539,1.539,0,0,1,45.568,23.3v1.911a1.64,1.64,0,0,0,3.253,0V23.3a4.618,4.618,0,0,0-4.88-4.3H23.88A4.618,4.618,0,0,0,19,23.3v13.38A4.618,4.618,0,0,0,23.88,40.981Z",
    transform: "translate(0)",
    fill: "#d68a26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.434,77.867H34.769a1.434,1.434,0,1,0,0-2.867H20.434a1.434,1.434,0,1,0,0,2.867Z",
    transform: "translate(0 -26.784)",
    fill: "#d68a26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.168,45H64.434a1.434,1.434,0,0,0,0,2.867h5.734a1.434,1.434,0,1,0,0-2.867Z",
    transform: "translate(-19.435 -12.435)",
    fill: "#d68a26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.168,60H64.434a1.434,1.434,0,0,0,0,2.867h5.734a1.434,1.434,0,1,0,0-2.867Z",
    transform: "translate(-19.435 -19.61)",
    fill: "#d68a26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.168,75H64.434a1.434,1.434,0,1,0,0,2.867h5.734a1.434,1.434,0,1,0,0-2.867Z",
    transform: "translate(-19.435 -26.784)",
    fill: "#d68a26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsIcon);
export default __webpack_public_path__ + "static/media/assets-icon.e1c8241c5b850b6878903c9081630e0f.svg";
export { ForwardRef as ReactComponent };